import { logger } from '../../logger.ts';

export async function getURLForLogin(originUrl: string = '/'): Promise<string | undefined> {
	if (!originUrl) originUrl = '/';

	let loginURL: string | undefined;
	try {
		const response = await fetch(`/up-teaserui/gateway/generateCustomerIdentityLoginUrl?originUrl=${originUrl}`, {
			credentials: 'include',
			method: 'GET',
			headers: { 'Content-Type': 'application/json' }
		});
		if (response.status === 200) {
			await response.json().then(response => {
				loginURL = response.encodedUrl;
			});
		} else {
			logger.error(`Status ${response.status} calling url generator`);
			loginURL = undefined;
		}

		return loginURL;
	} catch (error) {
		logger.error('Error generating url:' + error);
	}
}
